import React, { useContext, useMemo, useState } from "react";
import style from "./index.module.scss";
import { Button, Checkbox, Spin } from "antd";
import useRequest from "utils/useRequest";
import { CourseContext } from "../Store";
import CustomEmpty from "components/CourseComponents/CustomEmpty";
import { CheckboxValueType } from "antd/es/checkbox/Group";
import { CheckboxChangeEvent } from "antd/es/checkbox";
import Tools from "./Components/Tools";
import ListItem from "./Components/ListItem";
import { useHistory } from "react-router-dom";
import { getGroupList, queryGroupActivityList } from "../../../service/group";
import { GroupContext } from "./store";

export default function Group() {
    const history = useHistory();
    const { course, basename } = useContext(CourseContext);

    //活动列表
    const [activities, { loading }, refreshData] = useRequest(
        () =>
            queryGroupActivityList({
                courseNo: course.courseNo,
                courseSeq: course.courseSeq,
                weektimeId: course.weekTimeId
            }),
        {},
        [course]
    );

    const [groupList] = useRequest(
        () =>
            getGroupList({
                courseNo: course.courseNo,
                courseSeq: course.courseSeq,
                weektimeId: course.weekTimeId
            }),
        {},
        [course]
    );

    //选择 checkbox
    const [select, setSelect] = useState<CheckboxValueType[]>([]);
    const onCheckAllChange = (e: CheckboxChangeEvent) => {
        const plainOptions = activities?.map(item => item.activityBaseInfo.id);
        setSelect(e.target.checked ? plainOptions || [] : []);
    };

    //全选
    const checkAll = useMemo(() => {
        return select.length === activities?.length && select.length > 0;
    }, [select, activities]);

    return (
        <GroupContext.Provider value={{ groupList }}>
            <div className={style.root}>
                <div className={style.header}>
                    <div className={style.count}>
                        小组活动（{activities?.length || 0}）
                    </div>

                    <div className={style.tools}>
                        <Tools
                            select={select}
                            setSelect={setSelect}
                            refreshData={refreshData}
                            groupList={groupList || []}
                        />
                    </div>
                </div>

                <Spin spinning={loading}>
                    <div className={style.main}>
                        <dl className={style.dl}>
                            <dt className={style.dt}>
                                <Checkbox
                                    onChange={onCheckAllChange}
                                    indeterminate={
                                        select.length > 0 && !checkAll
                                    }
                                    checked={checkAll}
                                />
                            </dt>
                            <dd className={style.dd}>全选</dd>
                        </dl>
                        <Checkbox.Group
                            style={{ width: "100%" }}
                            value={select}
                            onChange={setSelect}>
                            {activities?.map(item => (
                                <dl
                                    key={item.activityBaseInfo.id}
                                    className={style.dl}>
                                    <dt className={style.dt}>
                                        <Checkbox
                                            value={item.activityBaseInfo.id}
                                        />
                                    </dt>
                                    <dd className={style.dd}>
                                        <ListItem
                                            item={item}
                                            updateList={refreshData}
                                        />
                                    </dd>
                                </dl>
                            ))}
                        </Checkbox.Group>

                        {(!activities || activities.length === 0) && (
                            <CustomEmpty
                                style={{ padding: "100px 0" }}
                                description={
                                    groupList && groupList.length !== 0 ? (
                                        <span>暂无活动</span>
                                    ) : (
                                        <span className={style.emptyColor}>
                                            暂无内容，请您点击
                                            <Button
                                                type="link"
                                                onClick={() =>
                                                    history.push(
                                                        `${basename}/group/settings/add`
                                                    )
                                                }>
                                                一键分组
                                            </Button>
                                            添加小组之后，创建活动。
                                        </span>
                                    )
                                }
                            />
                        )}
                    </div>
                </Spin>
            </div>
        </GroupContext.Provider>
    );
}
